export default "__VITE_ASSET__97fa7cbb__"